var STORAGE_KEYS = {
  FAVORITES: 'whereis_favorites',
  RECENT_VISITS: 'whereis_recent_visits',
  CUSTOM_SITES: 'whereis_custom_sites',
  THEME: 'whereis_theme'
};

// 收藏相关
export function getFavorites() {
  try {
    var data = localStorage.getItem(STORAGE_KEYS.FAVORITES);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('获取收藏失败:', error);
    return [];
  }
}

// 获取收藏的完整站点对象列表
export function getFavoritesList(allSites) {
  try {
    var favoriteIds = getFavorites();
    var customSites = getCustomSites();
    var allSitesList = [...allSites, ...customSites];
    return allSitesList.filter(function(site) {
      return favoriteIds.indexOf(String(site.id)) !== -1;
    });
  } catch (error) {
    console.error('获取收藏列表失败:', error);
    return [];
  }
}

export function addFavorite(siteOrId) {
  var favorites = getFavorites();
  var siteId = typeof siteOrId === 'object' ? String(siteOrId.id) : String(siteOrId);
  if (favorites.indexOf(siteId) === -1) {
    favorites.push(siteId);
    localStorage.setItem(STORAGE_KEYS.FAVORITES, JSON.stringify(favorites));   
  }
  return favorites;
}

export function removeFavorite(siteId) {
  var favorites = getFavorites();
  var id = String(siteId);
  var filtered = favorites.filter(function(favId) {
    return favId !== id;
  });
  localStorage.setItem(STORAGE_KEYS.FAVORITES, JSON.stringify(filtered));      
  return filtered;
}

export function isFavorite(siteId) {
  return getFavorites().indexOf(String(siteId)) !== -1;
}

// 最近访问相关
export function getRecentVisits(limit) {
  if (!limit) limit = 10;
  try {
    var data = localStorage.getItem(STORAGE_KEYS.RECENT_VISITS);
    var visits = data ? JSON.parse(data) : [];
    return visits.slice(0, limit);
  } catch (error) {
    console.error('获取最近访问失败:', error);
    return [];
  }
}

export function addRecentVisit(site) {
  var visits = getRecentVisits(50);
  // 移除已存在的相同项
  visits = visits.filter(function(v) {
    return v.id !== site.id;
  });
  // 添加到开头
  var newVisit = {
    id: site.id,
    name: site.name,
    category: site.category,
    icon: site.icon,
    url: site.url,
    description: site.description,
    color: site.color,
    isCustom: site.isCustom,
    visitTime: Date.now()
  };
  visits.unshift(newVisit);
  // 只保留最近50条
  visits = visits.slice(0, 50);
  localStorage.setItem(STORAGE_KEYS.RECENT_VISITS, JSON.stringify(visits));
  return visits;
}

// 自定义网站相关
export function getCustomSites() {
  try {
    var data = localStorage.getItem(STORAGE_KEYS.CUSTOM_SITES);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('获取自定义网站失败:', error);
    return [];
  }
}

export function addCustomSite(site) {
  var customSites = getCustomSites();
  var newSite = {
    name: site.name,
    category: site.category,
    icon: site.icon,
    url: site.url,
    description: site.description,
    color: site.color,
    id: Date.now(),
    isCustom: true
  };
  customSites.push(newSite);
  localStorage.setItem(STORAGE_KEYS.CUSTOM_SITES, JSON.stringify(customSites));
  return customSites;
}

export function updateCustomSite(siteId, updates) {
  var customSites = getCustomSites();
  var index = -1;
  for (var i = 0; i < customSites.length; i++) {
    if (customSites[i].id === siteId) {
      index = i;
      break;
    }
  }
  if (index !== -1) {
    customSites[index] = Object.assign({}, customSites[index], updates);
    localStorage.setItem(STORAGE_KEYS.CUSTOM_SITES, JSON.stringify(customSites));
  }
  return customSites;
}

export function deleteCustomSite(siteId) {
  var customSites = getCustomSites();
  var filtered = customSites.filter(function(site) {
    return site.id !== siteId;
  });
  localStorage.setItem(STORAGE_KEYS.CUSTOM_SITES, JSON.stringify(filtered));
  return filtered;
}

// 主题相关
export function getTheme() {
  try {
    return localStorage.getItem(STORAGE_KEYS.THEME) || 'light';
  } catch (error) {
    console.error('获取主题失败:', error);
    return 'light';
  }
}

export function setTheme(theme) {
  localStorage.setItem(STORAGE_KEYS.THEME, theme);
  document.documentElement.setAttribute('data-theme', theme);
  return theme;
}

// 导入/导出功能
export function exportData() {
  var data = {
    favorites: getFavorites(),
    customSites: getCustomSites(),
    recentVisits: getRecentVisits(50),
    theme: getTheme(),
    exportTime: new Date().toISOString()
  };
  return data;
}

export function importData(data) {
  try {
    if (data.favorites) {
      localStorage.setItem(STORAGE_KEYS.FAVORITES, JSON.stringify(data.favorites));
    }
    if (data.customSites) {
      localStorage.setItem(STORAGE_KEYS.CUSTOM_SITES, JSON.stringify(data.customSites));
    }
    if (data.theme) {
      setTheme(data.theme);
    }
    return true;
  } catch (error) {
    console.error('导入数据失败:', error);
    return false;
  }
}

// 初始化主题
export function initTheme() {
  var theme = getTheme();
  document.documentElement.setAttribute('data-theme', theme);
  return theme;
}
